import {generateEventTimingStatus} from '#core/application/modules/tiles/event-timing-status/index.js';
import {generatePriceBoostBanner} from '#core/application/modules/tiles/price-boost-banner/index.js';
import {generateOddsButton} from '#core/application/modules/tiles/odds-button/index.js';

export function selectionCardsFactory(PALETTE, COLOR_MODE) {
    return {
        SelectionCardClassic: {
            mode: COLOR_MODE,
            showBackgroundSportImage: !PALETTE.PARENT.CARD_WATERMARK_ICON_HIDDEN,
            competitorIconOptions: {
                icons: {
                    default: 'generic/team-kit-default.svg',
                },
            },
            priceBoostBanner: generatePriceBoostBanner(PALETTE.CARD_SELECTION_PRICE_BOOST_BANNER),
            eventCardDetails: generateSelectionEventCardDetails(PALETTE.CARD_EVENT_DETAILS_LIGHT),
            eventCardDetailsDark: generateSelectionEventCardDetails(PALETTE.CARD_EVENT_DETAILS_DARK),
        },
    };
}

function generateSelectionEventCardDetails(CARD_DETAILS) {
    const CARD_TIMING_STATUS = generateEventTimingStatus(CARD_DETAILS.TIMING_STATUS);

    return {
        sportIcon: {
            icon: {
                style: {
                    fill: CARD_DETAILS.SPORT_ICON_COLOR,
                    minWidth: 12,
                },
            },
        },
        countryIcon: {
            icon: {
                style: {
                    fill: CARD_DETAILS.SPORT_ICON_COLOR,
                    minWidth: 12,
                },
            },
        },
        genericEventCard: {
            title: {
                truncate: true,
                ellipsisOnLineNumber: 1,
                style: CARD_DETAILS.EVENT_NAME_TEXT,
            },
        },
        boostedEventCard: {
            title: {
                truncate: true,
                ellipsisOnLineNumber: 1,
                style: CARD_DETAILS.EVENT_NAME_TEXT,
            },
            clickableArea: {
                style: {
                    base: {
                        padding: '0 0 8px',
                    },
                },
            },
        },
        headerTime: CARD_TIMING_STATUS,
        headerLiveLabel: CARD_TIMING_STATUS.liveText,
        selectionName: {
            default: {
                style: {
                    lineHeight: '1.3', // better to set it here and store it as a string, cool Moj decision (selection-card.jsx:24)
                    ...CARD_DETAILS.SELECTION_NAME_TEXT,
                },
            },
            withPromotionText: {
                style: {
                    lineHeight: 1.3,
                    ...CARD_DETAILS.SELECTION_PROMOTION_TEXT,
                },
            },
        },
        marketName: {
            default: {
                style: {
                    ...CARD_DETAILS.SELECTION_MARKET_TEXT,
                },
            },
            withPromotionText: {
                style: {
                    lineHeight: 1.3,
                    ...CARD_DETAILS.SELECTION_MARKET_TEXT,
                },
            },
        },
        promotionText: {
            style: {
                lineHeight: 1.3,
                ...CARD_DETAILS.SELECTION_NAME_TEXT,
            },
        },
        selectionButton: generateOddsButton(CARD_DETAILS.ODDS_BUTTON),
        separatorLabel: {
            style: CARD_DETAILS.EVENT_NAME_TEXT,
        },
        threeParticipantText: {
            style: CARD_DETAILS.EVENT_NAME_TEXT,
        },
        participantItem: {
            participantWrapper: {
                style: {
                    flexGrow: 0,
                },
            },
            text: {
                style: CARD_DETAILS.EVENT_NAME_TEXT,
            },
        },
    };
}
